export default "__VITE_ASSET__BzF7U6wJ__"